import { render, staticRenderFns } from "./ExpirationsTableSaf.vue?vue&type=template&id=c88ed486&"
import script from "./ExpirationsTableSaf.vue?vue&type=script&lang=js&"
export * from "./ExpirationsTableSaf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports